import styled from "styled-components";
import { MarketingBuyersWrapper } from "../marketing-buyers/marketing-buyers.style";

export const FarmsDirectoryWrapper = styled(MarketingBuyersWrapper)`
  .audience-summary-grid.farm-summary { max-width: 680px; grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .farm-person { min-width: 190px; }
  .farm-person .buyer-avatar { border-radius: 50%; }
  .owner-contact { display: grid; gap: 2px; }
  .owner-contact strong { color: var(--dash-ink); font-size: 10px; }
  .owner-contact a, .owner-contact span { color: var(--dash-subtle); font-size: 9px; text-decoration: none; }
  .rating-value { color: var(--dash-ink); font-weight: 800; white-space: nowrap; }
  .rating-value small { color: var(--dash-subtle); font-size: 8px; font-weight: 500; }
  .farm-state { display: inline-flex; border-radius: 99px; padding: 5px 8px; font-size: 8px; font-weight: 800; white-space: nowrap; }
  .farm-state.positive { background: var(--dash-primary-soft); color: var(--dash-primary); }
  .farm-state.neutral { background: #f0f2f1; color: #68766e; }
  @media (max-width: 720px) {
    .audience-summary-grid.farm-summary { max-width: none; grid-template-columns: none; }
  }
`;
